import { Button } from '@mantine/core';
import { IconFileTypePdf } from '@tabler/icons-react';

import { Id } from '@feature/utils';

interface EvaluationReportButtonProps {
  evaluationId: Id;
  authorId: Id;
}

const onDownload = (evaluationId: Id, authorId: Id) => {
  window.open(`/api/author-evaluation/${evaluationId}/author/${authorId}/data/signed/pdf`);
};

export function EvaluationReportSignedButton({ evaluationId, authorId }: EvaluationReportButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypePdf size="24px" />}
      onClick={() => onDownload(evaluationId, authorId)}
    >
      Descarcă fișă de evaluare semnată
    </Button>
  );
}
